import {FC} from 'react';
import ColorsType from '../../types/ColorsType';
import UIColorCard from '../UICommon/UIColorCard';

type ChooseColorsFavoriteProps = {
  colors: ColorsType[];
  refetchFavorites: Function;
  setIsLoadingFavorites: Function;
  setChosenColors: Function;
  chosenColors: any;
}

const ChooseColorsFavorite: FC<ChooseColorsFavoriteProps> = ({
  colors,
  refetchFavorites,
  setIsLoadingFavorites,
  setChosenColors,
  chosenColors,
}) => {
  if (colors?.length === 0) {
    return (
      <div className='font-Outfit text-center flex items-center h-[90%] max-w-[192px] mx-auto'>
        Du har inga favoriter ännu. Klicka på hjärtat fär att lägga till bland favoriter
      </div>
    );
  }
  return (
    <div className='flex flex-wrap justify-between'>
      {colors?.map((el: ColorsType) => (
        <UIColorCard
          isFavorite={true}
          key={el.id}
          id={el.id}
          name={el.name}
          brand={el.brand}
          img={el.image}
          tone={el.tone}
          refetchFavorites={refetchFavorites}
          setIsLoadingFavorites={setIsLoadingFavorites}
          setChosenColors={setChosenColors}
          chosenColors={chosenColors}
          style='mb-8'
        />
      ))}
    </div>
  );
};

export default ChooseColorsFavorite;
